import { Editor } from 'ckeditor5';

export const exportCKEditorWord = (editorInstance: Editor | null) => {
  if (editorInstance) {
    const config = editorInstance.config.get('exportWord');
    editorInstance.execute('exportWord', config);
  }
};
